<script lang="ts">
	import { format } from 'svelte-i18n';
	import { edit } from 'src/stores/ui/edit_lists';
	import { getUserTimeZoneDate } from 'src/helpers/date_helper';
	import { capFirstChar } from 'src/helpers/utilities';
	import { getOverAllChartsConfig } from 'src/helpers/statistics/config/overall_consumption';
	import {
		LAYER_RANGE_OPTIONS,
		rangeDates,
		type ChartControlsDataInterface,
	} from 'src/helpers/statistics/ui/chart_control_helpers';
	import ConsumptionOverallChart from 'src/components/Consumption/ConsumptionOverallChart.svelte';

	const chartConfig = getOverAllChartsConfig('bar');
	const rangeOption = LAYER_RANGE_OPTIONS.find((option) => option.period === '24_hours');
	const chartControlsData: ChartControlsDataInterface = {
		time: rangeDates(getUserTimeZoneDate().date, rangeOption, 'init', true),
		format: 'Y-m-d H:i:s',
		rangeOption,
		currentPeriod: '24_hours',
	};
</script>

<!-- //A fixed height is applied to prevent drag-and-drop jumping and does not affect widget behavior on mobile or desktop. -->
<div
	style={`overflow: ${$edit ? 'hidden' : 'visible'};${$edit ? 'height:180px' : 'min-height:100%'}`}
	role="presentation"
>
	<div class="cursor-pointer" role="presentation" on:click>
		<ConsumptionOverallChart
			dashWidget={true}
			{chartConfig}
			{chartControlsData}
			reqURL={chartConfig.url}
			title={capFirstChar(
				$format('text_total_energy', {
					default: 'Total Energy',
				}),
			)}
			hideTooltip={$edit}
		/>
	</div>
</div>
